import { Component } from '@angular/core';
import { Mode } from '../../components/confirmation-code/mode.service';

@Component({
  selector: 'auth-registration-confirmation-code',
  templateUrl: './registration-confirmation-code.component.html',
  styleUrls: ['./registration-confirmation-code.component.scss']
})
export class RegistrationConfirmationCodeComponent {

  mode: Mode = Mode.REG;

  constructor() { }

}
